import { Component, EventEmitter, input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IconFieldModule } from '@openng/optimus-ui/iconfield';
import { InputIconModule } from '@openng/optimus-ui/inputicon';
import { InputTextModule } from '@openng/optimus-ui/inputtext';

@Component({
  selector: 'lib-search-component',
  standalone: true,
  imports: [FormsModule, IconFieldModule, InputIconModule, InputTextModule],
  templateUrl: './search-component.html'
})
export class SearchComponent {
  @Output() searchValueChange = new EventEmitter<string>();
  searchValue = '';
  placeholder = input<string>('Search');

  onSearchValueChange(value: string): void {
    this.searchValueChange.emit(value);
  }
}
